import { QueryClient } from '@tanstack/vue-query';

// Wspolny cache zapytan dla wszystkich wysp Vue (wzorzec jak sharedPinia).
// Kazda aplikacja tworzona przez createVueApp dostaje te sama instancje,
// wiec rownolegle wyspy deduplikuja identyczne requesty i wspoldziela dane.
export const sharedQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});
